import { useContext } from 'react'
import ThemeContext from 'contexts/ThemeContext'

const useThemeSwitcher = () => useContext(ThemeContext)

export default useThemeSwitcher
